<div class="md-container">
    <h3 class="lb-title-modal">Selecciona tu ciudad</h3>
    <p-table
        [value]="lsCiudad"
        [rows]="4"
        styleClass="font-size: 10px; p-datatable-sm;"
        [showCurrentPageReport]="true"
        scrollDirection="both"
        selectionMode="single" 
    >
        <ng-template pTemplate="header" let-columns>
            <tr class="header-table">
            </tr>
            <tr>
                <th scope="col" [hidden]="true">

                </th>
                <th *ngIf="!loading" scope="col">
                    <p-columnfilter 
                        class="filter-modal in-center"
                        type="text" 
                        field="Nombre"
                        placeholder="Buscar ciudad"
                        matchMode="contains"
                        [showMenu]="false" 
                    ></p-columnfilter>
                </th>
                <p-skeleton *ngIf="loading" height="3rem" styleClass="mb-2 sheleton-header"></p-skeleton>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-dataCiudad let-rowIndex="rowIndex">
            <tr style="cursor: pointer;" [pSelectableRow]="dataCiudad" (click)="onRowDblClick($event, dataCiudad)">
                <td [hidden] = "true">
                    {{dataCiudad.Id}}
                </td>
                <td class="center">
                    {{dataCiudad.Nombre | uppercase}}
                </td>
            </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
            <tr *ngIf="!loading">
                <td colspan="3">No existen registros.</td>
            </tr>
            <p-skeleton *ngIf="loading" height="3rem" styleClass="mb-2"></p-skeleton>
            <p-skeleton *ngIf="loading" height="3rem" styleClass="mb-2"></p-skeleton>
            <p-skeleton *ngIf="loading" height="3rem" styleClass="mb-2"></p-skeleton>
        </ng-template>
    </p-table>
</div>